import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'user-ui', {
    deleteProfilePicture: 'Delete profile picture',
    uploadProfilePicture: 'Upload profile picture',
    trashSelectedFactoids: 'Trash selected factoids',
    editFactoid: 'Edit factoid',
    trashFactoid: 'Trash factoid',
    duplicateSelectedSettings: 'Duplicate selected settings',
    deleteSelectedSettings: 'Delete selected settings',
    editSetting: 'Edit setting',
    duplicateSetting: 'Duplicate setting',
    deleteSetting: 'Delete setting',
    duplicateSelectedSettingTemplates: 'Duplicate selected setting templates',
    deleteSelectedSettingTemplates: 'Delete selected setting templates',
    editSettingTemplate: 'Edit setting template',
    duplicateSettingTemplate: 'Duplicate setting template',
    deleteSettingTemplate: 'Delete setting template',
    preferencesTab: 'Preferences',
    preferencesSearchPlaceholder: 'Search preferences…',
    preferencesEmpty: 'No preference templates match your search.',
    preferencesUngrouped: 'General',
    group_convo_name: 'Conversation display',
    group_convo_description: 'Control how coaching conversations are displayed.',
    'group_agent-convo_name': 'Agent conversation display',
    'group_agent-convo_description': 'Control how agentic runs are displayed.',
    'key_convo_show-tokens_name': 'Show Tokens',
    'key_convo_show-tokens_description':
      'Show token counts and costs in the chat footer and on messages.',
    'key_convo_show-reasoning_name': 'Show Reasoning',
    'key_convo_show-reasoning_description':
      'Show model reasoning and thinking parts while streaming.',
    'key_convo_show-tools_name': 'Show Tool Calls',
    'key_convo_show-tools_description': 'Show tool call cards in the message list.',
    'key_convo_show-details_name': 'Show Details',
    'key_convo_show-details_description': 'Expand message detail panels by default.',
    'key_convo_show-context_name': 'Show Context',
    'key_convo_show-context_description': 'Show the AI chat context panel.',
    'key_convo_show-raw_name': 'Show Raw JSON',
    'key_convo_show-raw_description':
      'Show the raw JSON tree for the conversation instead of the chat UI.',
    'key_agent-convo_show-tokens_name': 'Show Tokens',
    'key_agent-convo_show-tokens_description':
      'Show token counts and costs in the agent run footer and on messages.',
    'key_agent-convo_show-reasoning_name': 'Show Reasoning',
    'key_agent-convo_show-reasoning_description':
      'Show model reasoning and thinking parts while streaming.',
    'key_agent-convo_show-tools_name': 'Show Tool Calls',
    'key_agent-convo_show-tools_description': 'Show tool call cards in the agent message list.',
    'key_agent-convo_show-details_name': 'Show Details',
    'key_agent-convo_show-details_description': 'Expand agent message detail panels by default.',
    'key_agent-convo_show-context_name': 'Show Context',
    'key_agent-convo_show-context_description': 'Show the AI chat context panel.',
    'key_agent-convo_show-raw_name': 'Show Raw JSON',
    'key_agent-convo_show-raw_description':
      'Show the raw JSON tree for the agent run instead of the chat UI.',
    group_metrics_name: 'Metrics',
    group_metrics_description: 'Units and how measurements are shown across the app.',
    group_ui_name: 'User Interface',
    group_ui_description: 'Customize the look and feel of the application.',
    'key_metrics_unit-system_name': 'Unit System',
    'key_metrics_unit-system_description':
      'Use metric or US customary units for weights, distances, and other measurements.',
    key_ui_theme_name: 'Theme',
    key_ui_theme_description: 'Use light or dark mode for the application.',
    // Generic action words (reused across confirm / group-action copy below)
    delete: 'Delete',
    duplicate: 'Duplicate',
    trash: 'Trash',
    // AvatarControl
    deleteProfilePictureConfirmTitle: 'Delete profile picture?',
    deleteProfilePictureConfirmDescription: 'This will delete the current profile picture.',
    // FactoidGrid
    factoidTrashedSnack: 'Memory moved to the trash',
    factoidRestoreRefused: 'Could not restore the memory',
    factoidNounSingular: 'Factoid',
    factoidNounPlural: 'Factoids',
    factoidGroupTrashMatchingDescription:
      'Are you sure you want to move all {{count}} matching factoid to the trash?',
    factoidGroupTrashMatchingDescription_plural:
      'Are you sure you want to move all {{count}} matching factoids to the trash?',
    factoidGroupTrashSelectedDescription:
      'Are you sure you want to move the {{count}} selected factoid to the trash?',
    factoidGroupTrashSelectedDescription_plural:
      'Are you sure you want to move the {{count}} selected factoids to the trash?',
    factoidGroupTrashedSnack: '{{count}} factoid moved to trash',
    factoidGroupTrashedSnack_plural: '{{count}} factoids moved to trash',
    // SettingGrid
    settingDeleteConfirmTitle: 'Delete Setting',
    settingDeleteConfirmDescription: 'Are you sure you want to delete the setting "{{key}}"?',
    settingDeletedSnack: 'Setting deleted',
    settingDuplicatedSnack: 'Setting duplicated',
    settingAddRequiresLoginSnack: 'Must be logged in to add a setting',
    settingNounSingular: 'Setting',
    settingNounPlural: 'Settings',
    settingGroupDeletedSnack: '{{count}} setting deleted',
    settingGroupDeletedSnack_plural: '{{count}} settings deleted',
    settingGroupDuplicatedSnack: '{{count}} setting duplicated',
    settingGroupDuplicatedSnack_plural: '{{count}} settings duplicated',
    // SettingTemplateAdminPage
    settingTemplatesPageTitle: 'Setting Templates',
    // SettingTemplateGrid
    settingTemplateDeleteConfirmTitle: 'Delete Setting Template',
    settingTemplateDeleteConfirmDescription:
      'Are you sure you want to delete the template "{{key}}"?',
    settingTemplateDeleteConfirmDescriptionWithOverrides:
      'Are you sure you want to delete the template "{{key}}"? This will also delete {{overrideCount}} user override.',
    settingTemplateDeleteConfirmDescriptionWithOverrides_plural:
      'Are you sure you want to delete the template "{{key}}"? This will also delete {{overrideCount}} user overrides.',
    settingTemplateDeletedSnack: 'Setting template deleted',
    settingTemplateDuplicatedSnack: 'Setting template duplicated',
    settingTemplateNounSingular: 'Setting Template',
    settingTemplateNounPlural: 'Setting Templates',
    settingTemplateGroupDeleteDescription:
      'This will delete {{count}} setting template and {{overrideCount}} user override. This cannot be undone.',
    settingTemplateGroupDeleteDescription_plural:
      'This will delete {{count}} setting templates and {{overrideCount}} user overrides. This cannot be undone.',
    settingTemplateGroupDeletedSnack: '{{count}} setting template deleted',
    settingTemplateGroupDeletedSnack_plural: '{{count}} setting templates deleted',
    settingTemplateGroupDeletedWithOverridesSnack:
      '{{count}} setting template deleted (and {{overrideCount}} override)',
    settingTemplateGroupDeletedWithOverridesSnack_plural:
      '{{count}} setting templates deleted (and {{overrideCount}} overrides)',
    settingTemplateGroupDuplicatedSnack: '{{count}} setting template duplicated',
    settingTemplateGroupDuplicatedSnack_plural: '{{count}} setting templates duplicated',
    faqFooterStillHaveQuestion: 'You still have a question?',
    faqFooterContactUs:
      'If you cannot find a question in our FAQ, you can always contact us. We will answer to you shortly!',
    faqFooterAlwaysHappyToHelp: 'We are always happy to help!',
    faqFooterEmail: 'hello@help.com',
    faqFooterBestWayAnswer: 'Best way to get answer faster!',
    faqHeaderHello: 'Hello, how can we help?',
    faqHeaderChooseCategory: 'or choose a category to quickly find the help you need',
    faqHeaderSearchPlaceholder: 'Search a question....',
    faqNoResultsFound: 'No Results Found!!',
    pricingCtaStartTrial: 'Still not convinced? Start with a 14-day FREE trial!',
    pricingCtaFullAccess: 'You will get full access to with all the features for 14 days.',
    pricingCtaStartTrialButton: 'Start 14-day FREE trial',
    pricingFooterHelpAnswer: 'Let us help answer the most common questions.',
    pricingHeaderTitle: 'Pricing Plans',
    pricingHeaderDescription:
      'All plans include 40+ advanced tools and features to boost your product.',
    pricingHeaderChooseBestPlan: 'Choose the best plan to fit your needs.',
    pricingHeaderSaveUpTo10: 'Save up to 10%',
    pricingTablePickPlan: 'Pick a plan that works best for you',
    pricingTableMoneyBack: 'Stay cool, we have a 48-hour money back guarantee!',
    pricingTableChoosePlan: 'Choose Plan',
    // uvilo-ai factoid category1 vocabulary labels
    'factoidCategory1.identity': 'Identity',
    'factoidCategory1.perception': 'Perception',
    'factoidCategory1.relationships': 'Relationships',
    'factoidCategory1.education': 'Education',
    'factoidCategory1.skills': 'Skills',
    'factoidCategory1.work': 'Work',
    'factoidCategory1.projects': 'Projects',
    'factoidCategory1.interests': 'Interests',
    'factoidCategory1.coaching': 'Coaching',
    'factoidCategory1.preferences': 'Preferences',
    'factoidCategory1.values': 'Values',
    'factoidCategory1.media': 'Media',
    'factoidCategory1.milestones': 'Milestones',
    'factoidCategory1.habits': 'Habits',
    'factoidCategory1.events': 'Events',
    'factoidCategory1.goals': 'Goals',
    'factoidCategory1.plans': 'Plans',
    'factoidCategory1.worries': 'Worries',
    // uvilo-ai factoid category2 vocabulary labels (slot maps to life-domain values)
    'factoidCategory2.body': 'Body',
    'factoidCategory2.mind': 'Mind',
    'factoidCategory2.home': 'Home',
    'factoidCategory2.intimacy': 'Intimacy',
    'factoidCategory2.community': 'Community',
    'factoidCategory2.school': 'School',
    'factoidCategory2.work': 'Work',
    'factoidCategory2.business': 'Business',
    'factoidCategory2.money': 'Money',
    'factoidCategory2.parenting': 'Parenting',
    'factoidCategory2.caregiving': 'Caregiving',
    'factoidCategory2.play': 'Play',
    'factoidCategory2.growth': 'Growth',
    'factoidCategory2.purpose': 'Purpose',
    'factoidCategory2.general': 'General',
    // Life domain labels (kept for non-factoid consumers of user-ui)
    'lifeDomain.body': 'Body',
    'lifeDomain.mind': 'Mind',
    'lifeDomain.home': 'Home',
    'lifeDomain.intimacy': 'Intimacy',
    'lifeDomain.community': 'Community',
    'lifeDomain.school': 'School',
    'lifeDomain.work': 'Work',
    'lifeDomain.business': 'Business',
    'lifeDomain.money': 'Money',
    'lifeDomain.parenting': 'Parenting',
    'lifeDomain.caregiving': 'Caregiving',
    'lifeDomain.play': 'Play',
    'lifeDomain.growth': 'Growth',
    'lifeDomain.purpose': 'Purpose',
    'lifeDomain.general': 'General',
  });
}
